// src/utils/TopBar.jsx
import React from 'react';
import { Toolbar, Typography, IconButton, Box, Tooltip, Paper, Button } from '@mui/material';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { useThemeMode } from '../style/ThemeContext'; // تأكد من صحة المسار

export const TopBar = () => {
  const { mode, toggleColorMode } = useThemeMode();

  const handleLogout = () => {
  // هذه الدالة ستقوم بمسح كل محتويات localStorage بالكامل
  localStorage.clear();
  
  // التوجيه إلى صفحة تسجيل الدخول
  window.location.href = '/login'; 
};

  return (
    <Paper 
      variant='glass' 
      elevation={0} 
      sx={{
        position: 'sticky', // تم التصحيح هنا: position بدلاً من display
        top: '10px',
        mx: 2, // إضافة مسافة من اليمين واليسار (margin-horizontal) لجعله يطفو
        mb: 2, // مسافة من الأسفل ليبتعد عن المحتوى
        zIndex: (theme) => theme.zIndex.drawer + 1,
        // تمت إزالة backgroundColor و borderBottom لكي يعمل تأثير الزجاج بشكل مثالي
      }}
    >
      <Toolbar sx={{ minHeight: '64px' }}>
        
        {/* منطقة الشعار */}
        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography 
            variant="pageTitle" 
            component="div" 
            sx={{ 
              color: 'primary.main',
              cursor: 'pointer' 
            }}
          >
            التقييم الوصفي
          </Typography>
        </Box>

        {/* منطقة الأزرار والإعدادات */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          
          {/* زر الثيم */}
          <Tooltip title={mode === 'dark' ? "الوضع الفاتح" : "الوضع الداكن"}>
            <Button
              onClick={toggleColorMode} 
              variant='contained'
              color='secondary'
              sx={{px:'0px'}}
            >
              {mode === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
            </Button>
          </Tooltip>

          {/* زر تسجيل الخروج */}
          <Tooltip title="تسجيل الخروج">
            <Button 
              onClick={handleLogout} 
              variant='contained'
              color='warning'
              sx={{px:'0px'}}
            >
              <LogoutRoundedIcon />
            </Button>
          </Tooltip>

        </Box>

      </Toolbar>
    </Paper>
  );
};

export default TopBar;